import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

async function getActionCategories(id, filter) {
	if (!id) {
		const {data} = await axios.get(`/action_category`, {params: {...filter, sortBy: "id.desc"}});

		return data;
	}
	const {data} = await axios.get(`/action_category/${id}`);

	return data;
}

export function useActionCategory() {
	const [filter, filterActionCategories] = useState({
		page: 1,
		search: null,
		limit: 10,
	});
	const [actionCategoryId, actionCategoryById] = useState(null);
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["actionCategory", filter, actionCategoryId], async () =>
		getActionCategories(actionCategoryId, filter),
	);

	return {data, isLoading, isError, error, filter, filterActionCategories, actionCategoryById};
}

export const fetchActionCategory = actionCategoryId => {
	return axios.get(`/action_category/${actionCategoryId}`).then(res => res.data);
};

export function useDetailActionCategory(actionCategoryId) {
	return useQuery({
		queryKey: actionCategoryId && ["actionCategory", actionCategoryId],
		queryFn: key => fetchActionCategory(actionCategoryId),
		refetchOnMount: false,
		refetchOnWindowFocus: false,
		enabled: !!actionCategoryId,
	});
}

// options

export function useActionCategoryOptions() {
	const result = useQuery(
		["actionCategoryOptions"],
		async () => await axios.get(`/action_category`).then(res => res.data),
	);

	return result;
}
